import React from '../helpers/react';
import classList from 'ereader-core/dist/classList.js';
import {getHookClass} from '../helpers/cssHooks.js';

export default React.createClass({
	render : function(){
        let className = classList('tooltip-wrapper', this.props.showOn, getHookClass('Tooltip'));
        const ariaLabel = this.props.ariaText ? this.props.ariaText : '';
        const role = this.props.role ? this.props.role : '';
		return (
			<div className={className}>
				<div className="tooltip" role={role} aria-label={ariaLabel}>{this.props.children}</div>
			</div>
		);
	}
});


// WEBPACK FOOTER //
// ./src/components/Tooltip.js